module.exports = __webpack_public_path__ + "img/Gusto.600db017.svg";